import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { DtoCA } from "src/app/shared/models/states";
import { endpointsURL } from "src/app/constants/endpointsURL";
import { dtoPasoAFI } from "../models/convertToPDF.model";
import { forEach } from "@angular-devkit/schematics";

@Injectable({
  providedIn: "root",
})
export class StatesPetitionsService {
  env = environment.env;
  changeStatesPetitions = endpointsURL.changeStatesPetitions;
  solicitudCertificadoServiceURL = endpointsURL.solicitudCertificadoServiceURL;
  statesPetitionsTransitables = endpointsURL.statesPetitionsTransitables;
  tramitacionURL = endpointsURL.tramitacionURL;

  constructor(private httpClient: HttpClient) {}

  public getStatesTransitables(idPetition: string) {
    let params = new HttpParams().set("_identificador", idPetition);
    return this.httpClient.get<any>(
      `${this.env}${this.statesPetitionsTransitables}`,
      {
        params: params,
      }
    );
  }

  public changeToCA(dtoToCA: DtoCA) {
    return this.httpClient.put<any>(
      `${this.env}${this.solicitudCertificadoServiceURL}/correccion/solicitud`,
      dtoToCA
    );
  }
  public changeToPA(idPetition: string, comentario: string) {
    let params = new HttpParams();
    params = params.append("_identificador", idPetition);
    if (comentario) {
      params = params.append("_comentario", comentario);
    }
    return this.httpClient.get<any>(
      `${this.env}${this.changeStatesPetitions}cambiarEstadoPA`,
      { params: params }
    );
  }
  public changeToAN(idPetition: string, actualState: string): Observable<any> {
    let params = new HttpParams().set("_identificador", idPetition);
    params = params.append("_estado", actualState);

    return this.httpClient.post<any>(
      `${this.env}${this.changeStatesPetitions}cambiarEstadoAN`,
      {},
      { params: params }
    );
  }
  public changeToRE(idPetition: string, comentario: string, motivo: string) {
    let params = new HttpParams();
    params = params.append("_identificador", idPetition);
    params = params.append("_comentario", comentario);
    params = params.append("_motivo", motivo);
    return this.httpClient.post<any>(
      `${this.env}${this.changeStatesPetitions}cambiarEstadoRE`,
      {},
      { params: params }
    );
  }
  public changeToPC(
    idPetition: string,
    comentario: string,
    actualState: string
  ) {
    let params = new HttpParams();
    params = params.append("_identificador", idPetition);
    params = params.append("_comentario", comentario);
    params = params.append("_estado", actualState);

    return this.httpClient.post<any>(
      `${this.env}${this.changeStatesPetitions}cambiarEstadoPC`,
      {},
      { params: params }
    );
  }

  public changeToCR(idPetition: string) {
    let params = new HttpParams();
    params = params.append("_identificador", idPetition);

    return this.httpClient.post<any>(
      `${this.env}${this.tramitacionURL}certificado/edit/tramitacion/certificadoIndividual/cambiarEstadoCR`,
      {},
      { params: params }
    );
  }

  public previousStepToChangeToFI(
    idPetitions: string[]
  ): Observable<dtoPasoAFI[]> {
    let params = new HttpParams();

    idPetitions.forEach((e) => {
      params = params.append("_identificadores", e);
    });

    return this.httpClient.get<dtoPasoAFI[]>(
      `${this.env}${this.changeStatesPetitions}cambioFI/pasoPrevio`,
      { params: params }
    );
  }

  public chanteToFICertificatesOD(idPetitions: string[]) {
    let params = new HttpParams();

    idPetitions.forEach((e) => {
      params = params.append("_identificadores", e);
    });

    return this.httpClient.post<any>(
      `${this.env}${this.changeStatesPetitions}cambiarEstadoFirmadoODyCOC`,
      {},
      { params: params }
    );
  }

  public changeToFICertificates(dtoList: dtoPasoAFI[], files: any[]) {
    const fd = new FormData();
    fd.append("pasoPrevioAFIDto", JSON.stringify(dtoList));
    files.forEach((e, index) => {
      fd.append("files", e, dtoList[index].solicitudId);
    });
    return this.httpClient.post<any>(
      `${this.env}${this.changeStatesPetitions}cambioFI`,
      fd
    );
  }

  public chanteToFICOC(idPetitions: string[]) {
    let params = new HttpParams();

    idPetitions.forEach((e) => {
      params = params.append("_identificadores", e);
    });

    return this.httpClient.post<any>(
      `${this.env}${this.changeStatesPetitions}cambiarEstadoFirmadoODyCOC`,
      {},
      { params: params }
    );
  }

  public changeToFIAllCertificatesAtCR(): Observable<dtoPasoAFI[]> {
    return this.httpClient.get<dtoPasoAFI[]>(
      `${this.env}${this.changeStatesPetitions}certificadosEnCR/cambiarEstadoFI`
    );
  }

  /*Only for placa*/
  public changeToPFPlaca(idPetition: string, data: any) {
    data["id"] = idPetition;
    data["tipoEtiqueta"] = "";
    data["tipoHomologado"] = "";

    return this.httpClient.post<any>(
      `${this.env}${this.tramitacionURL}placa/edit/tramitacion/placaIndividual/cambiarEstadoPFichero`,
      data
    );
  }
}
